import { useQuery } from '@tanstack/react-query';
import { fetchFavoriteCategories } from '../services/examCategoryService';

export function useFavoriteCategories() {
  return useQuery({
    queryKey: ['favoriteCategories'],
    queryFn: async () => {
      const data = await fetchFavoriteCategories();
      return Array.isArray(data?.categories_list) ? data.categories_list : [];
    },
    staleTime: 3 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) => previousData ?? [],
  });
}
